export const APP_LOAD = 'APP_LOAD';
export const ASYNC_START = 'ASYNC_START';
export const ASYNC_END = 'ASYNC_END';
export const LOGIN = 'LOGIN';
export const LOGIN_UNLOAD = 'LOGIN_UNLOAD';
export const AGENCY = 'AGENCY';
export const AGENCY_UNLOADED = 'AGENCY_UNLOADED';
export const CODE_LIST = 'CODE_LIST';
export const SURVEY_LIST_UNLOADED = 'SURVEY_LIST_UNLOADED';
export const GET_BUSINESS_KIND_LIST = 'GET_BUSINESS_KIND_LIST';



// 아래 제거될 항목
export const REGISTER_PAGE_UNLOADED = 'REGISTER_PAGE_UNLOADED';
export const LOADED = 'LOADED';


// WEBPACK FOOTER //
// ./src/constants/common.js